import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { getPageShellDataSafely } from "@/services/contenful/getPageShellDataSafe";
import BrandRegistration from "@/components/CustomComponents/BrandRegistration";
import BRAND_REGISTRATION_CONSTANTS from "@/components/CustomComponents/BrandRegistration/brandRegistrationConstants";
import ContactUsForm from "@/components/CustomComponents/ContactUsForm";
import SaleForm from "@/components/CustomComponents/SaleForm";
import { useContentfulTranslations } from "@/utils/contentfulTranslations";
import { useLocale } from "@/hooks/useLocale";

import BackToTop from "@/components/backToTop";
const Loader = dynamic(() => import("@/components/loader"));
const Landing = dynamic(() => import("@/components/landing"));

const LandingPage = ({
  pageData = {},
  slugPath = "",
  apacConfigurationsData = {},
}) => {
  const router = useRouter();
  const locale = useLocale();
  const { contactFormConfig = {}, saleFormConfig = {} } =
    useContentfulTranslations();
  const contactFormConfiglabels =
    contactFormConfig?.[locale] || contactFormConfig?.en || {};
  const saleFormConfiglabels =
    saleFormConfig?.[locale] || saleFormConfig?.en || {};
  if (router.isFallback) {
    return <Loader loading={router.isFallback} />;
  }
  const slugWithBackToTop = ["/about-us", "/protoolbox"];

  if (slugWithBackToTop.includes(pageData?.slug)) {
    return (
      <>
        <Landing pageData={pageData} />
        <BackToTop topHeight={0} defaultThreshold={500} />
      </>
    );
  }

  switch (slugPath) {
    case "brand-registration":
      return (
        <BrandRegistration
          brandRegistrationData={BRAND_REGISTRATION_CONSTANTS}
        />
      );
    case "contact-form":
      return (
        <ContactUsForm
          formConfig={contactFormConfiglabels}
          contactFormConfigurationsData={apacConfigurationsData}
        />
      );
    case "after-sales-service-form":
      return (
        <SaleForm
          formConfig={saleFormConfiglabels}
          contactFormConfigurationsData={apacConfigurationsData}
        />
      );
    default:
      return <Landing pageData={pageData} />;
  }
};

export async function getServerSideProps({ params, preview, locale }) {
  // const { slug = "/" } = params;
  const slugArray = params?.slug || [];
  const slugPath = slugArray.join("/");
  const {
    items,
    headerNavigationData,
    footerNavigationData,
    promoBannerData,
    worldwideMenuData,
    apacConfigurationsData,
    translations,
  } = await getPageShellDataSafely({
    slug: slugPath ? `/${slugPath}` : "/",
    preview,
    contentType: "brazilLandingPage",
    fetchEntryBySlugFlag: true,
    locale,
  });

  const slugPathArray = [
    "brand-registration",
    "contact-form",
    "after-sales-service-form",
  ];
  const pageProps = {
    props: {
      headerNavigationData,
      footerNavigationData,
      promoBannerData,
      world: worldwideMenuData,
      apacConfigurationsData,
      translations,
    },
  };
  if (slugPathArray.includes(slugPath)) {
    pageProps.props.slugPath = slugPath;
    return pageProps;
  }

  const pageData = items?.[0]?.fields;
  if (!pageData) {
    return {
      notFound: true,
    };
  }
  pageProps.props.pageData = pageData;
  return pageProps;
}

LandingPage.propTypes = {
  pageData: PropTypes.object,
  slugPath: PropTypes.string,
  apacConfigurationsData: PropTypes.object,
};

export default LandingPage;
